import { useAuthManager } from '@doltech/core/lib/auth/authManager';
import * as React from 'react';
import { useBeforeUnload, useMount, useUnmount } from 'react-use';
import { nanoid } from 'nanoid';
import { ActivityTypeEnum } from '@doltech/utils/lib/constants';
import { postUserActivity } from './user-activity-tracking-api';

interface UserActivityTrackingProps {
  type?: ActivityTypeEnum;
}

export const withUserActivityTracking =
  (options?: UserActivityTrackingProps) => (WrappedComponent: any) => (props: any) => {
    const { type } = options;
    const { skill } = props;
    const sectionIdRef = React.useRef(nanoid());
    const authManager = useAuthManager();

    const handlePostUserActivityTracking = async () => {
      try {
        const userId = (await authManager.getUserInfo()).uid;
        await postUserActivity(
          {
            sessionId: sectionIdRef.current,
            type: type || skill,
            userId,
            activeAt: new Date().toISOString(),
          },
          userId
        );
      } catch (err) {
        console.log('User Activity Tracking Error', err);
        throw err;
      }
    };

    useMount(() => {
      handlePostUserActivityTracking();
    });

    useUnmount(() => {
      handlePostUserActivityTracking();
    });

    useBeforeUnload(() => {
      handlePostUserActivityTracking();
      return false;
    });

    return <WrappedComponent {...props} />;
  };
